import Image from 'next/image';

interface MultizoneLogoProps {
  widthClass?: string;
  heightClass?: string;
  sizes?: string;
  priority?: boolean;
  className?: string;
}

export default function MultizoneLogo({
  widthClass = 'w-40',
  heightClass = 'h-9',
  sizes = '160px',
  priority = false,
  className = 'object-contain object-left',
}: MultizoneLogoProps) {
  return (
    <div className={`relative ${heightClass} ${widthClass}`}>
      <Image
        src="/assets/images/normal-1777032697619.png"
        alt="Multizone Logo"
        fill
        sizes={sizes}
        className={className}
        priority={priority}
      />
    </div>
  );
}
